import React from 'react'
import styled, { css } from 'styled-components'

import Spinner from 'components/Spinner'

const buttonTypeStyle = ({ type }) => {
  if (type === 'primary') {
    return css`
      background: #0aa1f4;
      color: rgba(255, 255, 255, 1);
      border: none;

      path {
        fill: rgba(255, 255, 255, 1);
        fill-opacity: 1;
      }
    `
  } else if (type === 'accent') {
    return css`
      background: #92BF00;
      color: rgba(255, 255, 255, 1);
      border: none;

      path {
        fill: rgba(255, 255, 255, 1);
        fill-opacity: 1;
      }
    `
  } else if (type === 'error') {
    return css`
      background: rgba(225, 25, 0, 1);
      color: #FFFFFF;
      border: none;

      path {
        fill: #FFFFFF;
        fill-opacity: 1;
      }
    `
  } else if (type === 'delist') {
    return css`
      background: #FFF;
      color: #E11900;
      border: 1px solid #E11900;

      path {
        fill-opacity: 1;
        fill: #E11900;
      }
    `
  } else if (type === 'secondary') {
    return css`
      background: rgba(255, 255, 255, 1);
      color: #0aa1f4;
      border: ${(props) => {
    return props.border ? props.border : '1px solid #0aa1f4'
  }};

      path {
        fill: #0AA1F4;
        fill-opacity: 1;
      }
    `
  } else if (type === 'destructive') {
    return css`
      background: rgba(225, 25, 0, 0.1);
      color: rgba(225, 25, 0, 1);
      border: none;
    `
  } else if (type === 'disabledPrimary') {
    return css`
      background: rgba(10, 161, 244, 0.5);
      color: rgba(255, 255, 255, 1);
      border: none;

      path {
        fill: rgba(255, 255, 255, 1);
        fill-opacity: 1;
      }
    `
  } else if (type === 'cancelComments') {
    return css`
      background: #FFFFFF;
      color: rgba(32, 32, 32, 0.5);
      border: none;
      box-shadow: none;
      padding: 15px;
    `
  } else if (type === 'leftCommentButtons') {
    return css`
      background: #FFFFFF;
      color: rgba(32, 32, 32, 0.5);
      border: none;
      box-shadow: none;
      margin-right: 0;
      padding: 15px;

      svg {
        margin-right: 0;
      }
    `
  } else if (type === 'replyComments') {
    return css`
      background: rgba(32, 32, 32, 0.05);
      color: rgba(32, 32, 32, 1);
      border: none;
      box-shadow: none;
      padding: 8px 16px 8px 16px;
      border-radius: 4px;
      margin-right: 26px;
    `
  } else if (type === 'replies') {
    return css`
      text-decoration: underline;
      background: none;
      color: rgba(32, 32, 32, 1);
      border: none;
      box-shadow: none;
      padding-left: 10px;
    `
  } else if (type === 'noReplies') {
    return css`
      text-decoration: none;
      background: none;
      color: rgba(32, 32, 32, 0.7);
      border: none;
      box-shadow: none;
      padding-left: 10px;
    `
  } else if (type === 'hideReplies') {
    return css`
      text-decoration: none;
      background: none;
      color: rgba(32, 32, 32, 1);
      border: none;
      box-shadow: none;
      padding-left: 10px;
    `
  } else if (type === 'defaultDisabled') {
    return css`
      background: rgba(32, 32, 32, 0.05);
      color: rgba(32, 32, 32, 0.7);
      border: 1px solid rgba(32, 32, 32, 0.2);

      path {
        fill: rgba(32, 32, 32);
        fill-opacity: 0.5;
      }
    `
  }

  return css`
    background: rgba(255, 255, 255, 1);
    color: rgba(32, 32, 32, 1);
    border: 1px solid rgba(32, 32, 32, 0.2);
    box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);

    path {
      fill: rgba(32, 32, 32);
      fill-opacity: 0.5;
    }

  `
}

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Inter;
  border-radius: 4px;
  cursor: ${(p) => {
    return p.disabled ? 'not-allowed' : 'pointer'
  }};
  box-shadow: ${(props) => {
    return props.boxShadow ? props.boxShadow : '0 1px 2px rgba(32, 32, 32, 0.05)'
  }};
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  margin-top: ${(p) => {
    return p.marginTop
  }};
  margin-bottom: ${(p) => {
    return p.marginBottom
  }};
  width: ${(p) => {
    return p.width
  }};
  height: ${(p) => {
    return p.height
  }};
  padding: ${(p) => {
    return p.height === '48px' ? '0 24px' : '0 16px'
  }};

  svg {
    margin-right: 8px;
  }

  ${buttonTypeStyle}
`

const Button = ({
  dataTestId,
  children,
  onClick,
  isDisabled,
  isPending,
  dataTest,
  type,
  border,
  boxShadow,
  height = '48px',
  marginTop = '32px',
  width = 'auto',
  withIcon = false
}) => {
  return (
    <StyledButton
      data-testid={dataTestId ? dataTestId : 'test-button'}
      disabled={isDisabled}
      onClick={onClick}
      data-test={dataTest}
      type={type}
      border={border}
      boxShadow={boxShadow}
      height={height}
      marginTop={marginTop}
      width={width}
      withIcon={withIcon}
    >
      <>{isPending ? <Spinner /> : children}</>
    </StyledButton>
  )
}

export default Button
